import styled from 'styled-components';
import breakpoint from '~/utils/style-utils.ts';
import useUIContext from '~/ui/use-ui-context';
import { mainWrapperMinHeight, mainWrapperMinHeightSmaller } from '~/utils/layout-utils.js';

// ToDo: forceShowSidebar should be removed from app
const SubWrapperStyled = styled.main`
	display: grid;
	grid-area: main;
	min-height: ${({ uiContext }) => mainWrapperMinHeightSmaller(uiContext)};
	${breakpoint.lg`
    min-height: ${({ uiContext }) => mainWrapperMinHeight(uiContext)};
    grid-template-columns: auto;
  `};
`;

const SubWrapper = props => {
	const uiContext = useUIContext();
	return <SubWrapperStyled {...props} uiContext={uiContext} />;
};

export default SubWrapper;
